import i18n from '@/features/locales/i18n'
import alertbox from '@/utils/alertbox'
import DomPurify from 'dompurify'

export function useNotify() {
  const success = ({ title, html = '' } = {}) =>
    setTimeout(() => {
      alertbox({
        title: title || i18n.global.t('common.status.saveSuccessful'),
        html: DomPurify.sanitize(html),
        icon: 'fak fa-frt-select-all text-green-500'
      })
    }, 300)

  const error = ({ title, html = '', text }) =>
    setTimeout(() => {
      alertbox({
        title,
        html: DomPurify.sanitize(html),
        text,
        icon: 'fak fa-frt-warning text-amber-500'
      })
    }, 300)

  return {
    success,
    error
  }
}
